import { testimonials } from "@/data/testimonials";
import { Star } from "lucide-react";

export default function Testimonials() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 ">
      {testimonials.map((testimonial) => (
        <Testimonial key={testimonial.id} testimonial={testimonial} />
      ))}
    </div>
  );
}

type TestimonialType = (typeof testimonials)[number];

type TestimonialProps = {
  testimonial: TestimonialType;
};

export function Testimonial({ testimonial }: TestimonialProps) {
  return (
    <div className="py-6 px-4 bg-brand-neutral-650 rounded-lg flex flex-col justify-between mx-auto max-w-2xs">
      <p className="text-base">{testimonial.message}</p>
      <div className="flex w-full justify-between mt-4">
        <div>
          <h3 className="font-semibold">{testimonial.name}</h3>
          <p className="text-white/80">{testimonial.location}</p>
        </div>
        <RatingStars rating={testimonial.rating} />
      </div>
    </div>
  );
}

type RatingProps = {
  rating: number;
};

export function RatingStars({ rating }: RatingProps) {
  // Round to nearest 0.5
  const rounded = Math.round(rating * 2) / 2;
  return (
    <div className="flex items-center gap-1">
      {Array.from({ length: 5 }).map((_, i) => {
        const starNumber = i + 1;

        if (rounded >= starNumber) {
          return (
            <Star
              key={i}
              className="fill-brand-orange-500 text-brand-orange-500 size-5"
            />
          );
        } else if (rounded + 0.5 === starNumber) {
          return (
            <div key={i} className="relative size-5">
              <Star className="text-brand-neutral-600 size-5" />
              {/* left half filled */}
              <div className="absolute inset-0 overflow-hidden w-1/2">
                <Star className="fill-brand-orange-500 text-brand-orange-500 size-5" />
              </div>
            </div>
          );
        } else {
          // empty star
          return <Star key={i} className="text-brand-neutral-600 size-5" />;
        }
      })}
    </div>
  );
}
